import { useState } from "react"
import { Link } from "react-router-dom"
import Input from '../../../../shared/components/form/input'

import AuthBackgroundImage from '../../../../shared/components/AuthImage/AuthBackgroundImage'
import FormLayout from "../../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../../shared/components/FormLayout/FormSection"
import Button from "../../../../shared/components/Button/Button"

/* Hooks */
import useFlashMessage from '../../../../hooks/useFlashMessage'

function FormImgColor({ id, dataImg, title, handleSubmit, btCancelLink, btCancelAction, btnText }) {

    const [preview, setPreview] = useState()
    const [img, setImg] = useState({})
    const { setFlashMessage } = useFlashMessage()

    function onFileChange(e) {
        if (e.target.files[0]) {
            if (e.target.files[0].size > 1 * 1000 * 1024) {
                setFlashMessage("A imagem é maior que 1MB e não sera carregada", 'error')
                return
            }
        }

        setPreview(e.target.files[0])
        setImg({ [e.target.name]: e.target.files[0] })
    }

    const submit = (e) => {
        e.preventDefault()
        if (!img.image) {
            setFlashMessage("A imagem é obrigatória", 'error')
            return
        }
        if (!id) {
            setFlashMessage("O id é obrigatório", 'error')
            return
        }

        handleSubmit(img)
    }

    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelLink
                        ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                        : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                    }
                </>
            }
        >
            <FormSection label="Imagem">
                <div className="fl-row">
                    <div className="form-group">
                        {preview ? (
                            <div className='shd-box-img-300x300 shd-bgimg-cover' style={{ backgroundImage: `url(${URL.createObjectURL(preview)})` }} > </div>
                        ) : dataImg ? (
                            <AuthBackgroundImage className='shd-box-img-300x300 shd-bgimg-cover' src={`/images/color/${dataImg}`} />
                        ) : <div className='shd-box-img-300x300' ></div>}

                        <div>Atenção: Não serão carregadas imagens maiores que 1MB</div>
                        <Input
                            text="imagem"
                            type="file"
                            name="image"
                            handleOnChange={onFileChange}
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormImgColor
